import type { DetailPageConfig } from "@/components/shared/UniversalDetailPage/types/detailPage";
import type { Deal } from "@/lib/types/database/deals";
import { dealDetailTabs } from "../config/deal-detail-tabs";
import { dealDetailActions } from "@/lib/actions/definitions/entities";
import { dealDetailBreadcrumbs } from "../config/deal-detail-breadcrumbs";
import {
  dealTitleTemplate,
  dealDescriptionTemplate,
} from "../config/deal-detail-templates";

// ============================================================================
// DEAL DETAIL PAGE CONFIGURATION
// ============================================================================

export const ENHANCED_DEAL_DETAIL_CONFIG: DetailPageConfig<Deal> = {
  entity: "deals",
  displayName: "Deal",
  tabs: dealDetailTabs,
  actions: dealDetailActions as any,
  breadcrumbs: dealDetailBreadcrumbs,
  defaultTab: "details",
  showHeader: true,
  showBreadcrumbs: true,
  showActions: true,
  titleTemplate: dealTitleTemplate,
  descriptionTemplate: dealDescriptionTemplate,
};
